import React, { useState, useRef, useEffect } from "react";
import Sidebar from "../../components/SideBar";
import { motion, AnimatePresence } from "framer-motion";
import Location from "../../components/Location";
import NavBar from "../../commonComponents.jsx/NavBar";
import DatePickerWithInput from "../../commonComponents.jsx/DatePickerWithInput";
import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import CommonFooter from "../../commonComponents.jsx/CommonFooter";
import MultipleLocationModal from "../../components/MultipleLocationModal";
import PaymentChart from "../../components/PaymentChart";
import ProductSkeleton from "../../commonComponents.jsx/Skeleton";
import PaymentPieChart from "../../components/PaymentPieChart";
import FilterPopup from "../../commonComponents.jsx/FilterPopup";
import month from "../../images/monthsales.png";
import LocationDropdown from "../../commonComponents.jsx/LocationDropdown";
import {
  getCardBgForPayment,
  getCardIconBgForPayment,
  getCardIconForPayment,
} from "../../helpers/commonHelper";
import {
  fetchHourlyProductSaleDataLocwise,
  fetchHourlyProductSummaryDataLocwise,
} from "./Api";
import HourlySalesGraph from "../../components/HourlySalesGraph";
import down from "../../images/address.png";

const HourlyProductSummary = () => {
  const sidebarRef = useRef(null);
  const locationRef = useRef(null);
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const [isSideBar, setIsSideBar] = useState(false);
  const [isLocation, setIsLocation] = useState(false);
  const [reportType, setReportType] = useState(null);
  const [filteredSales, setFilteredSales] = useState([]);
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [pending, setPending] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [filterLocations, setFilterLocations] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [apply, setApply] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedAllLocation, setSelectedAllLocation] = useState([]);

  const today = new Date().toISOString().split("T")[0];
  const [dashboardDatas, setDashboardData] = useState({
    summary: [],
    locationWise: [],
  });
  const [hasMultipleLocations, setHasMultipleLocations] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);


  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");

  const queryClient = useQueryClient();

  useEffect(() => {
    const storedInfo = sessionStorage.getItem("adminInfo");
    if (storedInfo) {
      try {
        const adminInfo = JSON.parse(storedInfo);
        const selectedLoc = JSON.parse(
          sessionStorage.getItem("selectedLocation") || "null",
        );
        const hasMulti =
          Array.isArray(adminInfo?.multiple_location) &&
          adminInfo.multiple_location.length > 0;
        setSelectedLocation(selectedLoc);
        setHasMultipleLocations(hasMulti);
      } catch (error) {
        console.error("Error parsing adminInfo:", error);
        setHasMultipleLocations(false);
      }
    } else {
      setHasMultipleLocations(false);
    }
  }, []);

  // const handleLocationSubmit = ({ summary, locationWise, pending }) => {
  //   setDashboardData({ summary, locationWise, pending });
  // };

  const handleLocationSubmit = ({
    summary,
    locationWise,
    pending,
    selectedAllLocation,
  }) => {
    const mappedLocations = selectedAllLocation.map((item) => ({
      locationID: item.id,
      locationName: item.name,
    }));
    setFilterLocations([]);
    setSelectedAllLocation(mappedLocations);
    sessionStorage.setItem(
      "selectedAllLocation",
      JSON.stringify(mappedLocations),
    );
    queryClient.resetQueries(["hourly-product-summary"]);
    setDashboardData({ summary, locationWise, pending });
  };

  useEffect(() => {
    const stored = sessionStorage.getItem("selectedAllLocation");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.length > 0) {
          setSelectedAllLocation(parsed);
        }
      } catch (e) {
        console.error("Error parsing selectedAllLocation:", e);
      }
    }
  }, []);

  const [fromDate, setFromDate] = useState(() => {
    const now = new Date();
    const threeAM = new Date(now);
    threeAM.setHours(3, 0, 0, 0);

    const fromDateObj =
      now < threeAM ? new Date(now.setDate(now.getDate() - 1)) : now;

    return fromDateObj.toISOString().split("T")[0];
  });

  const [toDate, setToDate] = useState(() => {
    const now = new Date();
    const threeAM = new Date(now);
    threeAM.setHours(3, 0, 0, 0);

    const fromDateObj =
      now < threeAM ? new Date(now.setDate(now.getDate() - 1)) : now;

    return fromDateObj.toISOString().split("T")[0];
  });

  const clientid = sessionStorage.getItem("clientId");
  const filteredLocationsId = filterLocations.map((item) => item.locationID);

  useEffect(() => {
    const hasShownModal = sessionStorage.getItem(
      "hasShownMultipleLocationModal",
    );
    const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "null");

    if (
      !hasShownModal &&
      adminInfo &&
      Array.isArray(adminInfo.multiple_location) &&
      adminInfo.multiple_location.length > 0
    ) {
      setIsLocationModalOpen(true);
      sessionStorage.setItem("hasShownMultipleLocationModal", "true");
    }
  }, []);

  const fetchLocations = async ({ queryKey }) => {
    const [, { clientid, locations }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid || locations.length === 0) {
      throw new Error("Missing required parameters");
    }

    const requestBody = {
      clientid: clientid,
      dataurl: "/api/Location",
      type: "get",
      subdata: {
        loations: locations,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const shouldFetchLocations = adminInfo?.multiple_location?.length === 0;
  const { data: locationData = [] } = useQuery({
    queryKey: ["locations", { clientid, locations }],
    queryFn: fetchLocations,
    enabled: shouldFetchLocations && !!clientid && locations.length > 0,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (locationData.length > 0 && filterLocations.length === 0) {
      setFilterLocations([locationData[0]]);
    }
  }, [locationData]);

  const {
    data: saleData = {},
    isFetching: saleFetching = false,
    isLoading: saleLoading,
  } = useQuery({
    queryKey: [
      "hourly-product-sale",
      fromDate,
      toDate,
      page,
      limit,
      selectedCard,
    ],

    queryFn: () => {
      if (
        (filteredLocationsId && filteredLocationsId.length > 0) ||
        selectedCard
      ) {
        return fetchHourlyProductSaleDataLocwise({
          fromDate,
          toDate,
          page,
          limit,
          selectedCard,
          filteredLocationsId,
          locations,
        });
      }
      return null;
    },

    enabled:
      !!sessionStorage.getItem("clientId") &&
      !!sessionStorage.getItem("token") &&
      JSON.parse(sessionStorage.getItem("locations") || "[]").length > 0 &&
      !!fromDate &&
      !!filteredLocationsId &&
      !!selectedCard &&
      adminInfo.multiple_location &&
      adminInfo.multiple_location.length > 0
        ? selectedLocation !== null
        : true,

    staleTime: 0,
    cacheTime: 0,
    onSettled: () => {
      setApply(0);
    },
  });

  console.log(filteredLocationsId);
  

  const {
    data: dashboardData = {},
    isFetched,
    isFetching,
    isLoading: summaryLoading,
  } = useQuery({
    queryKey: ["hourly-product-summary", fromDate, toDate, apply,filteredLocationsId],

    queryFn: () => {
      if (filteredLocationsId && filteredLocationsId.length > 0) {
        return fetchHourlyProductSummaryDataLocwise({
          fromDate,
          toDate,
          filteredLocationsId,
        });
      }
      return null;
    },

    enabled:
      !!sessionStorage.getItem("clientId") &&
      !!sessionStorage.getItem("token") &&
      JSON.parse(sessionStorage.getItem("locations") || "[]").length > 0 &&
      !!fromDate &&
      !!filteredLocationsId &&
      adminInfo.multiple_location &&
      adminInfo.multiple_location.length > 0
        ? selectedLocation !== null
        : true,

    staleTime: 0,
    cacheTime: 0,
    onSettled: () => {
      setApply(0);
    },
  });

 

  const locationDatas = shouldFetchLocations
    ? locationData
    : selectedAllLocation;



  let dashboardSummary =
    dashboardDatas?.summary?.length > 0
      ? dashboardDatas.summary
      : (dashboardData?.summary ?? []);

  const groupedData = React.useMemo(() => {
    if (!dashboardSummary?.length) return [];

    const grouped = dashboardSummary.reduce((acc, item) => {
      if (!acc[item.locationID]) {
        acc[item.locationID] = {
          locationID: item.locationID,
          locationName: item.locationName,
          details: [],
        };
      }

      acc[item.locationID].details.push({
        hour: item.hour,
        amount: item.amount,
        hourRange: item.hourRange,
      });

      return acc;
    }, {});
    return Object.values(grouped).sort((a, b) => a.locationID - b.locationID);
  }, [dashboardSummary]);

  const clientData = JSON.parse(
    sessionStorage.getItem("clientSettings") || "null",
  );

  const toggleLocationSelection = (location) => {
    setFilterLocations((prev) => {
      if (prev.length === 1 && prev[0].locationID === location.locationID) {
        return [];
      }

      return [location];
    });
  };

  const handleApplyFilter = () => {
    setIsFilterOpen(false);
    setApply((prev) => prev + 1);
    setDashboardData([]);
  };

  const handleResetFilter = () => {
    setApply(0);
    setFromDate(today);
    setToDate(today);
    setFilterLocations([]);
    setIsFilterOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsSideBar(false);
      } else if (
        locationRef.current &&
        !locationRef.current.contains(event.target)
      ) {
        setIsLocation(false);
      }
    };

    if (isSideBar || isLocation || isDropdownOpen || isFilterOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "auto";
    };
  }, [isSideBar, isLocation, isDropdownOpen, isFilterOpen]);

  const getDisplayText = (locations) => {
    if (locations.length === 0) {
      return "All Locations";
    }

    return locations.length > 2
      ? `${locations[0].locationName}, +${locations.length - 1} more`
      : locations.map((location) => location.locationName).join(", ");
  };

  return (
    <div className="h-[100dvh] bg-gray-50 overflow-hidden">
      <div className="max-w-[768px] mx-auto relative">
        <AnimatePresence>
          {isSideBar && (
            <>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.5 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 bg-black z-50 "
                onClick={() => setIsSideBar(false)}
              />
              <motion.div
                initial={{ x: -300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -300, opacity: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 20,
                  duration: 0.3,
                }}
                className="absolute w-80 h-full overflow-hidden overflow-y-auto z-50 bg-white"
              >
                <Sidebar
                  onHide={() => setIsSideBar(false)}
                  page={"Hourly Product Summary"}
                />
              </motion.div>
            </>
          )}
        </AnimatePresence>

        <AnimatePresence>
          {isLocation && (
            <>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.5 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 bg-black z-50 "
                onClick={() => setIsLocation(false)}
              />
              <motion.div
                initial={{ y: 600, opacity: 0 }}
                animate={{ y: 100, opacity: 1 }}
                exit={{ y: 600, opacity: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 20,
                  duration: 0.3,
                }}
                className="absolute w-full h-full rounded-xl overflow-y-auto z-50 bg-white"
              >
                <Location
                  clientData={clientData}
                  subReport={filteredSales}
                  onBack={() => setIsLocation(false)}
                  reportType={reportType}
                />
              </motion.div>
            </>
          )}
        </AnimatePresence>

        {selectedCard && (
          <AnimatePresence>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8 }}
              className="fixed mb-[50px] inset-0 bg-black/50 z-50 flex items-end justify-center"
              onClick={() => setSelectedCard(null)}
            >
              <motion.div
                initial={{ y: "100%", opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: "100%", opacity: 0 }}
                transition={{ type: "spring", stiffness: 200, damping: 60 }}
                className="bg-white rounded-t-3xl w-full max-w-[768px] p-6 max-h-[80vh] flex flex-col"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Header */}
                <div className="flex justify-between items-center ">
                  <motion.h2
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.15 }}
                    className="font-QBold text-md"
                  >
                    Hour Details
                  </motion.h2>

                  <motion.button
                    whileTap={{ scale: 0.85, rotate: 90 }}
                    transition={{ duration: 0.2 }}
                    onClick={() => setSelectedCard(null)}
                  >
                    <i className="ri-close-line text-xl text-gray-500" />
                  </motion.button>
                </div>
                <motion.p
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 0.35 }}
                  className="font-QSemiBold text-xs"
                >
                  Location:{saleData?.data?.[0]?.locationName}
                </motion.p>

                {/* Summary */}
                <motion.div
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2 }}
                  className="flex gap-4 mb-4"
                >
                  <span className="text-sm font-QSemiBold text-gray-600">
                    Hour Range:{" "}
                    <span className="text-black">{selectedCard.hourRange}</span>
                  </span>
                  <span className="text-sm font-QSemiBold text-gray-600">
                    Amount:{" "}
                    <span className="text-black">
                      {selectedCard.amount?.toFixed(3)}
                    </span>
                  </span>
                </motion.div>

                {/* Table */}
                <div className="overflow-y-auto flex-1">
                  {saleLoading || saleFetching ? (
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      className="text-center py-6 text-gray-400 font-QSemiBold"
                    >
                      Loading...
                    </motion.div>
                  ) : saleData?.data?.length > 0 ? (
                    <table className="w-full text-sm">
                      <thead className="bg-gray-100 sticky top-0">
                        <tr>
                          <th className="text-left p-2 font-QSemiBold text-gray-600">
                            Product
                          </th>
                          <th className="text-right p-2 font-QSemiBold text-gray-600">
                            Qty
                          </th>
                          <th className="text-right p-2 font-QSemiBold text-gray-600">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {saleData.data.map((item, i) => (
                          <motion.tr
                            key={i}
                            initial={{ opacity: 0, x: -15 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: i * 0.05, duration: 0.25 }}
                            className="border-b border-gray-100"
                          >
                            <td className="p-2 font-QMedium text-gray-700">
                              {item.productDescription}
                            </td>
                            <td className="p-2 font-QMedium text-right text-gray-700">
                              {item.qty}
                            </td>
                            <td className="p-2 font-QMedium text-right text-gray-700">
                              {item.amount?.toFixed(3)}
                            </td>
                          </motion.tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95 }}
                      animate={{ opacity: 1, scale: 1 }}
                      className="text-center py-6 text-gray-400 font-QSemiBold"
                    >
                      No data available.
                    </motion.div>
                  )}
                </div>

                {/* Pagination */}
                {saleData?.totalPages > 1 && (
                  <motion.div
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    className="flex justify-between items-center pt-1 border-t border-gray-100"
                  >
                    <motion.button
                      whileTap={{ scale: 0.92 }}
                      disabled={!saleData?.hasPreviousPage}
                      onClick={() => setPage((prev) => prev - 1)}
                      className="px-4 py-2 rounded-xl text-sm font-QSemiBold bg-indigo-100 text-indigo-700 disabled:opacity-40"
                    >
                      Previous
                    </motion.button>
                    <span className="text-sm font-QSemiBold text-gray-500">
                      {saleData?.currentPageNumber} / {saleData?.totalPages}
                    </span>
                    <motion.button
                      whileTap={{ scale: 0.92 }}
                      disabled={!saleData?.hasNextPage}
                      onClick={() => setPage((prev) => prev + 1)}
                      className="px-4 py-2 rounded-xl text-sm font-QSemiBold bg-indigo-100 text-indigo-700 disabled:opacity-40"
                    >
                      Next
                    </motion.button>
                  </motion.div>
                )}
              </motion.div>
            </motion.div>
          </AnimatePresence>
        )}
        <div className="bg-[#F3F3F3] rounded-3xl overflow-y-auto shadow-sm p-4 h-[100dvh]">
          <NavBar onSideBar={() => setIsSideBar(true)} />
          <div className="flex justify-between items-center">
            {adminInfo?.multiple_location &&
            adminInfo.multiple_location.length > 0 ? (
              <button
                onClick={() => setIsLocationModalOpen(true)}
                className="mt-4 px-4 py-2 flex justify-between items-center gap-x-2 bg-indigo-700 rounded-xl text-white mb-3 text-sm font-QMedium tracking-tight  whitespace-nowrap"
              >
                Locations
                <img src={down} className="w-5 h-5" alt="" />
              </button>
            ) : (
              <LocationDropdown
                dropdownRef={dropdownRef}
                isDropdownOpen={isDropdownOpen}
                setIsDropdownOpen={setIsDropdownOpen}
                filterLocations={filterLocations}
                locations={locationData}
                toggleLocationSelection={toggleLocationSelection}
                getDisplayText={getDisplayText}
                onApply={() => {
                  setApply((prev) => prev + 1);
                  // setIsDropdownOpen(false);
                }}
              />
            )}
            <button
              onClick={() => setIsFilterOpen(true)}
              className="flex h-11 items-center gap-1 bg-indigo-100 rounded-[8px] px-3 py-2 shadow-sm hover:bg-indigo-200 transition-colors"
            >
              <i className="ri-filter-line text-indigo-600"></i>
              <span className="text-sm font-QSemiBold text-indigo-700">
                Filter
              </span>
            </button>
          </div>

          <div>
            <FilterPopup
              ref={filterRef}
              isOpen={isFilterOpen}
              onClose={() => setIsFilterOpen(false)}
              fromDate={fromDate}
              setFromDate={setFromDate}
              toDate={toDate}
              setToDate={setToDate}
              locations={locationDatas}
              selectedLocations={filterLocations}
              toggleLocationSelection={toggleLocationSelection}
              getDisplayText={getDisplayText}
              onReset={handleResetFilter}
              onApply={handleApplyFilter}
            />
          </div>
          <div className="flex flex-col space-y-3">
            <DatePickerWithInput
              label="From Date"
              value={fromDate}
              onChange={setFromDate}
            />
            <DatePickerWithInput
              label="To Date"
              value={toDate}
              onChange={setToDate}
            />
          </div>

          {/* {adminInfo?.multiple_location &&
          adminInfo.multiple_location.length > 0 ? (
            <button
              onClick={() => setIsLocationModalOpen(true)}
              className="mt-4 px-4 py-2 rounded-md text-sm font-QSemiBold text-gray-800 whitespace-nowrap"
              style={{ background: "#CDD7FF" }}
            >
              Select Locations
            </button>
          ) : (
            ""
          )} */}

          {summaryLoading || pending ? (
            <ProductSkeleton />
          ) : dashboardSummary && dashboardSummary.length > 0 ? (
            <>
              {/* {groupedData.length === 0 && (
                <div className="grid grid-cols-2 gap-4 my-8">
                  {dashboardSummary.map((item, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{
                        type: "spring",
                        stiffness: 80,
                        damping: 15,
                        duration: 0.3,
                        delay: index * 0.2,
                        ease: "easeOut",
                      }}
                      whileHover={{
                        scale: 1.05,
                        transition: { duration: 0.1, ease: "easeInOut" },
                      }}
                      className="w-full relative"
                    >
                      <Card
                        icon={getCardIconForPayment(item?.paymentDesc)}
                        bgIcon={getCardIconBgForPayment(item?.paymentDesc)}
                        currency={clientData?.mainCurrencyName}
                        paymentDesc={item?.paymentDesc}
                        amount={item?.amount}
                        tips={item?.tips}
                        bg={getCardBgForPayment(item?.paymentDesc)}
                        accentColor="bg-gradient-to-r from-indigo-100 to-indigo-200"
                      />
                    </motion.div>
                  ))}
                </div>
              )} */}
              {groupedData.length > 0 && (
                <div className=" gap-4 my-8">
                  {groupedData.map((item, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{
                        type: "spring",
                        stiffness: 80,
                        damping: 15,
                        duration: 0.3,
                        delay: index * 0.2,
                        ease: "easeOut",
                      }}
                      className="w-full relative"
                    >
                      {item?.locationName && (
                        <h1 className="font-QSemiBold text-sm">
                          Location : {item.locationName}
                        </h1>
                      )}
                      <div className="grid grid-cols-2 gap-4 my-8">
                        {item?.details?.map((item, i) => (
                          <Card
                            key={i}
                            amount={item?.amount}
                            Hour={item?.hour}
                            hourRange={item?.hourRange}
                            bgIcon={month}
                            accentColor="bg-gradient-to-r from-indigo-100 to-indigo-200"
                            onClick={() => {
                              setSelectedCard(item);
                              setPage(1);
                            }}
                          />
                        ))}
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}
              {!summaryLoading &&
                !isFetching &&
                (dashboardSummary && dashboardSummary.length > 0 ? (
                  <HourlySalesGraph
                    title={"Hourly Product Summary"}
                    hourlyData={dashboardSummary}
                  />
                ) : (
                  <div className="text-center py-10 text-gray-500 font-QSemiBold">
                    No hourly sales data available.
                  </div>
                ))}
            </>
          ) : (
            <div className="text-center text-gray-500 font-QSemiBold py-10">
              No summary data available.
            </div>
          )}

          <MultipleLocationModal
            isOpen={isLocationModalOpen}
            date={fromDate}
            toDate={toDate}
            onClose={() => setIsLocationModalOpen(false)}
            onDataSubmit={handleLocationSubmit}
            dataUrl={"Restaurant/GetHourlyProductwiseSale/Summary"}
            onPendingChange={setPending}
          />

          <div className="h-20" />
          <CommonFooter page={"Daily Payment Summary"} />
        </div>
      </div>
    </div>
  );
};

const Card = ({
  Hour,
  bgIcon,
  amount,
  onClick,
  hourRange,
  index = 0,
  highlight = false,
}) => {
  const gradients = [
    "from-indigo-500 via-indigo-600 to-indigo-700",
    "from-purple-500 via-purple-600 to-purple-700",
    "from-pink-500 via-pink-600 to-pink-700",
    "from-blue-500 via-blue-600 to-blue-700",
    "from-emerald-500 via-emerald-600 to-emerald-700",
    "from-orange-500 via-orange-600 to-orange-700",
  ];

  const gradient = gradients[index % gradients.length];

  return (
    <div
      onClick={onClick}
      className={`
        relative overflow-hidden cursor-pointer
        rounded-2xl p-4 text-white
        bg-gradient-to-br ${gradient}
        transition-all duration-300 ease-in-out
        ${
          highlight
            ? "shadow-xl scale-[1.03]"
            : "hover:shadow-lg hover:scale-[1.02]"
        }
      `}
    >
      <div className="absolute -z-0 -top-1 opacity-30 -right-2  mb-1  w-32 h-32 ">
        <img src={bgIcon} alt="Sales" />
      </div>

      <div className="relative z-10 flex flex-col items-center text-center">
        <h3 className="text-sm font-QSemiBold tracking-wide opacity-90">
          Hour Range : {hourRange}
        </h3>

        <div className="w-10 h-[2px] bg-white/40 my-2 rounded-full"></div>

        <p className="text-sm font-QBold">Amount : {amount.toFixed(3)}</p>
      </div>
    </div>
  );
};

// Reusable Nav Button Component

export default HourlyProductSummary;
